import React, { Component } from "react";
import { Link } from "react-router-dom";
import atencao from "../../img/atencao.svg";
import logo from "../../img/logo.png";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { saveAs } from "file-saver";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faAngleRight,
  faArrowLeft,
  faArrowRight,
  faBuilding,
  faClipboard,
  faCoffee,
  faEnvelope,
  faEye,
  faFileAlt,
  faFileExcel,
  faFileInvoice,
  faFilePdf,
  faFileText,
  faFlag,
  faHome,
  faIdCard,
  faMapMarkerAlt,
  faMobileAlt,
  faPen,
  faPhone,
  faPrint,
  faRefresh,
  faSave,
  faSearch,
  faTrash,
  faUser,
  faUserPlus,
  faUserTimes,
} from "@fortawesome/free-solid-svg-icons";
import { StaticDialog, useDialog } from "react-st-modal";
import InputMask from "react-input-mask";

import { toast } from "react-toastify";
import { apiUrl } from "../../comps/apiUrl";
import { Grid, MenuItem, TextField } from "@mui/material";

class Finances extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      add: false,
      dados: {},
      items: [],
      currentPage: 0, // Começa em 0 para a primeira página
      paginaAtual: 1,
      itemsPerPage: 100,
      termoPesquisa: "",
      edit: {},
      trash: {},
      busca: true,
      delmaster: {},
      viewProducts: {},
      comprovante: {},
      blockUser: {},
      filter: "1",
      equipamentos: {},
      faturamento: null,
      useFilter: false,
      dw: false,
    };
    this.page = React.createRef();
  }

  Generate_token(length) {
    //edit the token allowed characters
    var a =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split(
        ""
      );
    var b = [];
    for (var i = 0; i < length; i++) {
      var j = (Math.random() * (a.length - 1)).toFixed(0);
      b[i] = a[j];
    }
    return b.join("");
  }
  mudarPagina = (numeroPagina) => {
    this.setState({ paginaAtual: numeroPagina });
  };

  componentDidMount() {
    document.title = "Histórico de Finanças";
    this.LoadResults(1, 100);
  }

  handleSearch = (e) => {
    var btn = e.target;
    const { filter, start_date, end_date, faturamento, busca } = this.state;

    this.LoadResults(
      1,
      100,
      filter,
      start_date,
      end_date,
      faturamento,
      btn,
      false
    );
  };

  LoadResults = (
    page,
    l,
    filter,
    start_date,
    end_date,
    faturamento,
    btn,
    busca = true
  ) => {
    if (btn != undefined) {
      btn.classList.add("load");
    }
    fetch(
      `${apiUrl}/finances?page=${page}&limit=${l}&filter=${filter}&start_day=${start_date}&end_day=${end_date}&busca=${faturamento}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("token"),
        },
      }
    ).then((response) => {
      if (response.status == 510) {
        localStorage.clear();
        window.location.href = "/";
        return;
      }

      response.json().then((data) => {
        if (btn != undefined) {
          btn.classList.remove("load");
        }
        const totalItems = data.totalItems; // Simulado, substitua pelo valor real do backend.
        const totalPages = Math.ceil(totalItems / this.state.itemsPerPage);

        this.setState({
          items: data.items,
          currentPage: page,
          totalLc: data.totalLc,
          totalSc: data.totalSc,
          totalFn: data.totalFn,
          totalPages,
          busca,
          loader: false,
        });
      });
    });
  };

  Payment_type(t) {
    if (t == "boletop") {
      return (
        <span class="badge bg-danger" style={{ cursor: "pointer" }}>
          <FontAwesomeIcon icon={faFlag} /> Boleto Pendente
        </span>
      );
    } else if (t == "boletoa") {
      return (
        <span class="badge bg-success" style={{ cursor: "pointer" }}>
          <FontAwesomeIcon icon={faFlag} /> Boleto Aprovado
        </span>
      );
    } else if (t == "pix") {
      return <span class="badge bg-success">Pix</span>;
    } else if (t == "boleto") {
      return <span class="badge bg-success">Boleto</span>;
    } else if (t == "cartaod") {
      return <span class="badge bg-success">Cartão de debito</span>;
    } else if (t == "cartaoc") {
      return <span class="badge bg-success">Cartão de credito</span>;
    } else if (t == "dinheiro") {
      return <span class="badge bg-success">Dinheiro</span>;
    } else if (t == "pne") {
      return (
        <span class="badge bg-danger" style={{ cursor: "pointer" }}>
          <FontAwesomeIcon icon={faFlag} /> Pagamento na Entrega
        </span>
      );
    } else if (t == "pnd") {
      return (
        <span class="badge bg-danger" style={{ cursor: "pointer" }}>
          <FontAwesomeIcon icon={faFlag} /> Pagamento na Devoluão
        </span>
      );
    } else if (t == "boletonp") {
      return (
        <span class="badge bg-dark" style={{ cursor: "pointer" }}>
          <FontAwesomeIcon icon={faFlag} /> Boleto Não Pago
        </span>
      );
    } else if (t == "boletoe") {
      return (
        <span class="badge bg-success" style={{ cursor: "pointer" }}>
          <FontAwesomeIcon icon={faFlag} /> Boleto Emitido
        </span>
      );
    }
  }
  handlePageClick = (page) => {
    this.LoadResults(page, 100);
  };

  formatarDataBR(dataISO) {
    if (dataISO == null) {
      return "---";
    }
    // Converte a string ISO em um objeto Date
    const data = new Date(dataISO);

    // Extrai as partes da data
    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0"); // Meses começam do zero
    const ano = data.getFullYear();

    // Extrai as partes do horário
    const horas = String(data.getHours()).padStart(2, "0");
    const minutos = String(data.getMinutes()).padStart(2, "0");

    // Retorna no formato brasileiro
    return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
  }

  handleChange = (event) => {
    const { id, value } = event.target;

    // Atualizando o estado dentro do objeto `dados`
    this.setState((prevState) => ({
      dados: {
        ...prevState.dados, // Mantém os outros campos do objeto `dados`
        [id]: value, // Atualiza apenas o campo correspondente
      },
    }));
  };

  handlePageChange = (page) => {
    const { filter, start_date, end_date, faturamento, busca } = this.state;
    var filtro = busca == true ? "undefined" : filter;
    this.LoadResults(page, 100, filtro, start_date, end_date, faturamento);
  };
  handleEdit = (event) => {
    const { id, value } = event.target;

    // Atualizando o estado dentro do objeto `dados`
    this.setState((prevState) => ({
      edit: {
        ...prevState.edit, // Mantém os outros campos do objeto `dados`
        [id]: value, // Atualiza apenas o campo correspondente
      },
    }));
  };
  formatDate(dateString) {
    var e = dateString.split("-");
    var dateString = e[2] + "/" + e[1] + "/" + e[0];
    return dateString;
  }
  handleCpfCnpjChange = (e) => {
    function cnpj(v) {
      v = v.replace(/\D/g, ""); //Remove tudo o que não é dígito
      v = v.replace(/^(\d{2})(\d)/, "$1.$2"); //Coloca ponto entre o segundo e o terceiro dígitos
      v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3"); //Coloca ponto entre o quinto e o sexto dígitos
      v = v.replace(/\.(\d{3})(\d)/, ".$1/$2"); //Coloca uma barra entre o oitavo e o nono dígitos
      v = v.replace(/(\d{4})(\d)/, "$1-$2"); //Coloca um hífen depois do bloco de quatro dígitos
      return v;
    }

    function cpf(v) {
      v = v.replace(/\D/g, ""); //Remove tudo o que não é dígito
      v = v.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
      v = v.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
      //de novo (para o segundo bloco de números)
      v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2"); //Coloca um hífen entre o terceiro e o quarto dígitos
      return v;
    }

    if (e.target.value.length > 18) return;
    var value = e.target.value;
    if (e.target.value.length <= 14) {
      this.setState((prevState) => ({
        dados: {
          ...prevState.dados, // Mantém os outros campos do objeto `dados`
          ["doc"]: cpf(value), // Atualiza apenas o campo correspondente
        },
      }));
    } else {
      this.setState((prevState) => ({
        dados: {
          ...prevState.dados, // Mantém os outros campos do objeto `dados`
          ["doc"]: cnpj(value), // Atualiza apenas o campo correspondente
        },
      }));
    }
  };

  renderPagination() {
    const { currentPage, totalPages } = this.state;
    const maxPagesToShow = 5;
    const pages = [];

    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = startPage + maxPagesToShow - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    // Se necessário, adiciona a primeira página e reticências
    if (startPage > 1) {
      pages.push(
        <button
          key={1}
          onClick={() => this.handlePageChange(1)}
          className={`btn ${
            currentPage === 1 ? "btn-primary text-white" : "btn-outline-primary"
          }`}
          style={{
            borderRadius: "10%",
            width: "50px",
            height: "40px",
            fontWeight: "bold",
          }}
        >
          1
        </button>
      );

      if (startPage > 2) {
        pages.push(
          <span key="start-ellipsis" style={{ padding: "0 5px" }}>
            ...
          </span>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => this.handlePageChange(i)}
          className={`btn ${
            currentPage === i ? "btn-primary text-white" : "btn-outline-primary"
          }`}
          style={{
            borderRadius: "10%",
            width: "50px",
            height: "40px",
            fontWeight: "bold",
          }}
        >
          {i}
        </button>
      );
    }

    // Se necessário, adiciona reticências e a última página
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <span key="end-ellipsis" style={{ padding: "0 5px" }}>
            ...
          </span>
        );
      }

      pages.push(
        <button
          key={totalPages}
          onClick={() => this.handlePageChange(totalPages)}
          className={`btn ${
            currentPage === totalPages
              ? "btn-primary text-white"
              : "btn-outline-primary"
          }`}
          style={{
            borderRadius: "10%",
            width: "50px",
            height: "40px",
            fontWeight: "bold",
          }}
        >
          {totalPages}
        </button>
      );
    }

    return (
      <div className="d-flex justify-content-center align-items-center gap-2">
        <button
          className="btn btn-outline-primary"
          disabled={currentPage === 1}
          onClick={() => this.handlePageChange(currentPage - 1)}
          style={{
            borderRadius: "20px",
            padding: "8px 15px",
            display: "flex",
            gap: "5px",
            alignItems: "center",
          }}
        >
          <FontAwesomeIcon icon={faArrowLeft} /> Anterior
        </button>

        {pages}

        <button
          className="btn btn-outline-primary"
          disabled={currentPage === totalPages}
          onClick={() => this.handlePageChange(currentPage + 1)}
          style={{
            borderRadius: "20px",
            padding: "8px 15px",
            display: "flex",
            gap: "5px",
            alignItems: "center",
          }}
        >
          Próximo <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </div>
    );
  }

  render() {
    if (this.state.loader) {
      return (
        <div class="area-loader">
          <div class="loader"></div>
        </div>
      );
    }
    var invoicingType = {
      1: "Diária",
      2: "Semanal",
      3: "Quizenal",
      4: "Mensal",
      5: "Anual",
    };

    var priceType = {
      1: "day_price",
      2: "weekly_price",
      3: "biweekly_price",
      4: "monthly_price",
      5: "annual_price",
    };

    return (
      <>
        <div class="content">
          <div className="card mb-3">
            <div class="card-header d-flex align-items-center justify-content-between">
              <strong>Filtro</strong>
              <div>
                <button
                  className="btn btn-success"
                  onClick={() => {
                    const rentals = this.state.items;

                    // Transformando os dados para Excel
                    const excelData = [];

                    rentals.forEach((rental) => {
                      rental.products.forEach((product) => {
                        excelData.push({
                          ID: rental.id,
                          Vendedor: rental.seller_name,
                          Cliente: rental.client_name,
                          "ID Cliente": rental.client_id,
                          "Tipo Pagamento": rental.payment_type,
                          "Valor Locação": rental.location_value,
                          "Custo Frete": rental.shipping_cost,
                          Multa: rental.fine_f,
                          "Código Produto": product.codigo_barra,
                          Produto: product.name,
                          Quantidade: product.quantiny,
                          "Preço Diário": product.day_price,
                          "Preço Semanal": product.weekly_price,
                          "Preço Quinzenal": product.biweekly_price,
                          "Preço Mensal": product.monthly_price,
                          "Data Início": rental.start_day,
                          "Data Fim": rental.end_day,
                        });
                      });
                    });

                    // Criar planilha
                    const worksheet = XLSX.utils.json_to_sheet(excelData);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(
                      workbook,
                      worksheet,
                      "Aluguéis"
                    );

                    // Gerar arquivo e baixar
                    XLSX.writeFile(workbook, "alugueis.xlsx");
                  }}
                >
                  <FontAwesomeIcon icon={faFileExcel} />
                </button>
                <button
                  className="btn btn-danger"
                  style={{ marginLeft: 10 }}
                  onClick={() => {
                    const doc = new jsPDF({
                      orientation: "portrait",
                      unit: "mm",
                      format: "a4",
                      marginLeft: 0, // Remove a margem esquerda
                      marginRight: 0, // Remove a margem direita
                      marginTop: 0, // Remove a margem superior
                      marginBottom: 0, // Remove a margem inferior
                    });

                    // 2️⃣ Adiciona um título ao PDF
                    doc.setFontSize(16);

                    const data = this.state.items.map((item) => [
                      item.client_name,
                      item.payment_type,
                      invoicingType[item.billing],
                      item.location_value.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      }),
                      item.shipping_cost != null
                        ? item.shipping_cost.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        : "R$ 0,00",
                      item.fine_f != null
                        ? item.fine_f.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        : "R$ 0,00",
                      item.location_value + item.shipping_cost + item.fine_f,
                      new Date(item.start_day).toLocaleDateString(),
                      new Date(item.end_day).toLocaleDateString(),
                    ]);

                    // 4️⃣ Cabeçalhos das colunas
                    const headers = [
                      [
                        "Cliente",
                        "Metodo de Pagamento",
                        "Faturamento",
                        "Valor da Locação",
                        "Frete",
                        "Multa",
                        "Total",
                        "Locação",
                        "Devolução",
                      ],
                    ];

                    // 5️⃣ Adiciona a tabela ao PDF
                    doc.autoTable({
                      head: headers,
                      margin: 0,
                      body: data,
                    });

                    // 6️⃣ Salva o PDF com nome "relatorio.pdf"
                    doc.save(this.Generate_token(6) + ".pdf");
                  }}
                >
                  <FontAwesomeIcon icon={faFilePdf} />
                </button>
                <button
                  style={{ marginLeft: 10 }}
                  disabled={this.state.busca}
                  className="btn btn-primary"
                  onClick={() => {
                    this.setState({});
                    this.LoadResults(1, 100);
                  }}
                >
                  <FontAwesomeIcon icon={faRefresh} />
                </button>
              </div>
            </div>

            <div className="card-body">
              <Grid container spacing={2} alignItems="flex-start">
                {" "}
                {/* spacing creates gaps between items */}
                {/* Filter by: Dropdown */}
                <Grid item xs={12} sm={6} md={3}>
                  {" "}
                  {/* Adjust grid size as needed for different screen sizes */}
                  <TextField
                    label="Filtrar por:"
                    select
                    fullWidth
                    InputProps={{
                      style: {
                        height: 45,
                        padding: "0 5px",
                      },
                    }}
                    value={this.state.filter}
                    onChange={(e) =>
                      this.setState({
                        filter: e.target.value,
                        faturamento: undefined,
                      })
                    }
                  >
                    <MenuItem value="1">Cliente</MenuItem>
                    <MenuItem value="2">Faturamento</MenuItem>
                    <MenuItem value="3">Data da Locação</MenuItem>
                    <MenuItem value="4">Data de Vencimento</MenuItem>
                    <MenuItem value="6">Data de Pagamento</MenuItem>
                    <MenuItem value="7">Método de Pagamento</MenuItem>
                    <MenuItem value="8">Equipamento</MenuItem>
                  </TextField>
                </Grid>
                {/* Conditional Input/Select */}
                <Grid item xs={12} sm={6} md={5}>
                  {this.state.filter === "7" && (
                    <TextField
                      label="Metodo de Pagamento"
                      select
                      fullWidth
                      InputProps={{
                        style: {
                          height: 45,
                          padding: "0 5px",
                        },
                      }}
                      className=""
                      onChange={(e) =>
                        this.setState({ faturamento: e.target.value })
                      }
                    >
                      <MenuItem value="pix">PIX</MenuItem>
                      <MenuItem value="cartaoc">Cartão de Crédito</MenuItem>
                      <MenuItem value="cartaod">Cartão de Débito</MenuItem>
                      <MenuItem value="boletop">Boleto Emitido</MenuItem>
                      <MenuItem value="pne">Pagamento na Entrega</MenuItem>

                      <MenuItem value="dinheiro">Dinheiro</MenuItem>

                      <MenuItem value="todos">Todos</MenuItem>
                    </TextField>
                  )}
                  {this.state.filter === "1" && (
                    <TextField
                      label="Nome do Cliente"
                      fullWidth
                      InputProps={{
                        style: {
                          height: 45,
                          padding: "0 5px",
                        },
                      }}
                      onChange={(e) => {
                        if (e.target.value.length == 0) {
                          this.setState({
                            useFilter: false,
                            filteredItems: [],
                          });
                        }
                        this.setState({ faturamento: e.target.value });
                      }}
                    />
                  )}
                  {this.state.filter === "2" && (
                    <TextField
                      label="Faturamento"
                      select
                      fullWidth
                      InputProps={{
                        style: {
                          height: 45,
                          padding: "0 5px",
                        },
                      }}
                      onChange={(e) =>
                        this.setState({ faturamento: e.target.value })
                      }
                    >
                      <MenuItem value="1">Diária</MenuItem>
                      <MenuItem value="2">Semanal</MenuItem>
                      <MenuItem value="3">Quinzenal</MenuItem>
                      <MenuItem value="4">Mensal</MenuItem>
                      <MenuItem value="5">Anual</MenuItem>
                      <MenuItem value="todos">Todos</MenuItem>
                    </TextField>
                  )}

                  {this.state.filter === "8" && (
                    <TextField
                      label="Nome do Equipamento"
                      fullWidth
                      InputProps={{
                        style: {
                          height: 45,
                          padding: "0 5px",
                        },
                      }}
                      onChange={(e) => {
                        if (e.target.value.length == 0) {
                          this.setState({
                            useFilter: false,
                            filteredItems: [],
                          });
                        }
                        this.setState({ faturamento: e.target.value });
                      }}
                    />
                  )}
                </Grid>
                {/* Start Date */}
                <Grid item xs={12} sm={6} md={2}>
                  {" "}
                  {/* Adjust grid size */}
                  <TextField
                    type="date"
                    InputProps={{
                      style: {
                        height: 45,
                        padding: "0 5px",
                      },
                    }}
                    fullWidth // Make it take full width of its grid column
                    onChange={(e) => {
                      this.setState({
                        start_date: e.target.value,
                      });
                    }}
                    // You might want to add a label here, e.g., label="Data de Início"
                    InputLabelProps={{
                      shrink: true, // This makes the label always "shrunk" for date inputs
                    }}
                  />
                </Grid>
                {/* End Date */}
                <Grid item xs={12} sm={6} md={2}>
                  {" "}
                  {/* Adjust grid size */}
                  <TextField
                    type="date"
                    InputProps={{
                      style: {
                        height: 45,
                        padding: "0 5px",
                      },
                    }}
                    fullWidth // Make it take full width of its grid column
                    onChange={(e) => {
                      this.setState({
                        end_date: e.target.value,
                      });
                    }}
                    // You might want to add a label here, e.g., label="Data Final"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </Grid>
            </div>
            <div className="card-footer d-flex justify-content-end">
              <button
                type="submit"
                className="btn btn-primary"
                onClick={(e) => {
                  this.handleSearch(e);
                }}
              >
                <FontAwesomeIcon icon={faSearch} /> Buscar
              </button>
            </div>
          </div>

          <div class="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <strong>Lista</strong>
            </div>
            <div class="card-body">
              {this.state.items.length > 0 ? (
                <>
                  {this.renderPagination()}
                  <div className="mt-3" ref={this.page}>
                    <table class="table table-striped table-bordered arvore-l">
                      <thead class="thead-dark">
                        <tr>
                          <th>Cliente</th>
                          <th>Tipo de Operação</th>
                          <th>Metodo de Pagamento</th>
                          <th>Equipamentos</th>
                          <th>Faturamento</th>
                          <th>Valor Locação</th>
                          <th>Frete</th>
                          <th>Multa</th>
                          <th>Total</th>
                          <th>Locação</th>
                          <th>Devolução</th>
                          <th>Data de Pagamento</th>
                          <th>Ação</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.items.map((item, index) => (
                          <>
                            <tr>
                              <td>
                                <Link
                                  to={`/cadastro-clientes/view/${item.client_id}`}
                                >
                                  {item.client_name}
                                </Link>
                              </td>
                              <td>
                                {item.tdo == undefined
                                  ? "---"
                                  : item.tdo == 1
                                  ? "Locação"
                                  : "Renovação"}
                              </td>
                              <td>{this.Payment_type(item.payment_type)} </td>
                              <td>
                                <button
                                  className="btn btn-primary"
                                  onClick={() => {
                                    this.setState({
                                      equipamentos: item.products,
                                    });
                                  }}
                                >
                                  <FontAwesomeIcon icon={faEye} />
                                </button>
                              </td>

                              <td>{invoicingType[item.billing]}</td>
                              <td>
                                {item.location_value == null
                                  ? "R$ 0,00"
                                  : item.location_value.toLocaleString(
                                      "pt-BR",
                                      {
                                        style: "currency",
                                        currency: "BRL",
                                      }
                                    )}
                              </td>

                              <td>
                                {item.shipping_cost != null
                                  ? item.shipping_cost.toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })
                                  : "R$ 0,00"}
                              </td>
                              <td>
                                {item.fine_f != null
                                  ? item.fine_f.toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })
                                  : "R$ 0,00"}
                              </td>
                              <td>
                                {(
                                  item.location_value +
                                  item.shipping_cost +
                                  (item.fine_f != null ? item.fine_f : 0)
                                ).toLocaleString("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                })}
                              </td>
                              <td>{this.formatarDataBR(item.start_day)}</td>
                              <td>
                                {item.return_day == null
                                  ? "---"
                                  : this.formatarDataBR(item.return_day)}
                              </td>
                              <td>
                                {item.payment_a == null
                                  ? "---"
                                  : this.formatarDataBR(item.payment_a)}
                              </td>
                              <td>
                                <button
                                  className="btn btn-danger"
                                  onClick={() => {
                                    this.setState({
                                      delmaster: item,
                                    });
                                  }}
                                >
                                  <FontAwesomeIcon icon={faTrash} /> Excluir
                                </button>
                              </td>
                            </tr>
                          </>
                        ))}
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>
                            {this.state.totalLc.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                          </td>
                          <td>
                            {this.state.totalSc.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                          </td>
                          <td>
                            {this.state.totalFn.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                          </td>
                          <td>
                            {(
                              this.state.totalLc +
                              this.state.totalSc +
                              this.state.totalFn
                            ).toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {this.renderPagination()}
                </>
              ) : (
                <div className="text-center">
                  <strong>Não foram encontrados registros</strong>
                </div>
              )}
            </div>

            <div
              className="card-footer"
              style={{ display: "flex", justifyContent: "center" }}
            ></div>
          </div>
        </div>
        <StaticDialog
          isOpen={Object.keys(this.state.equipamentos).length > 0}
          title="Equipamentos"
          onAfterClose={(result) => {
            this.setState({ equipamentos: {} });
          }}
        >
          <div className="content">
            <table class="table table-striped table-bordered arvore-l">
              <thead class="thead-dark">
                <tr>
                  <th>Nome</th>
                  <th>Quantidade</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(this.state.equipamentos).length > 0 &&
                  this.state.equipamentos.map((item, index) => (
                    <>
                      <tr>
                        <td>{item.name}</td>
                        <td>{item.quantiny}</td>
                      </tr>
                    </>
                  ))}
              </tbody>
            </table>
          </div>
        </StaticDialog>
        <StaticDialog
          isOpen={Object.keys(this.state.delmaster).length > 0}
          title="Tem certeza de que deseja continuar?"
          onAfterClose={(result) => {
            this.setState({ delmaster: {} });
          }}
        >
          <div style={{ margin: 10 }}>
            Se vocé confirmar a exclusão, não sera possivel recuperar os dados
            posteriormente.
          </div>

          <div className="modal-fotter">
            <button
              className="btn btn-danger"
              onClick={(e) => {
                e.target.classList.add("load");

                var id = this.state.delmaster.id;

                fetch(`${apiUrl}/delete-lease`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    authorization: localStorage.getItem("token"),
                    // outras headers, se necessário
                  },
                  body: JSON.stringify({ id }), // corpo da requisição em formato JSON
                })
                  .then((response) => {
                    e.target.classList.remove("load");
                    if (response.status == 200) {
                      toast.success("Locação removida com sucesso!");
                      this.setState((prevState) => ({
                        items: prevState.items.filter((item) => item.id !== id),
                        filteredItems: prevState.items.filter(
                          (item) => item.id !== id
                        ),
                        delmaster: {},
                      }));
                    }
                  })
                  .catch((error) => {
                    toast.error("Erro ao enviar dados:", error);
                  });
              }}
            >
              <FontAwesomeIcon icon={faTrash} /> Excluir
            </button>
          </div>
        </StaticDialog>
      </>
    );
  }
}

export default Finances;
